export default {
  403: {
    title: 'アクセス権限がありません',
    description: '管理者に連絡してください',
  },
  404: {
    title: 'ページが見つかりません',
    description: 'お探しのページは見つかりませんでした。URLが間違っているか、ページが削除された可能性があります。',
  },
  backToHome: 'ホームに戻る',
};
